const ACTIONS = Object.freeze({
    models: {
        editAccess: "Edit model access",
        createModel: "Create model",
        createCustomModel: "Create Custom model",
        cloneModel: "Clone model",
    },
    modelParameters: {
        delete: "Delete model parameter",
        parameterSettingsUpdate: "Update model parameter settings",
        versionDelete: "Delete model parameter version",
        deployModel: "Deploy Model",
        undeployModel: "Undeploy Model",
        uploadModel: "Upload model parameter",
        updateModel: "Update model parameter",
    },
    scans: {
        getScans: "Get scans",
        markAsMeasurements: "Mark scans as measurements",
        deleteScans: "Delete scans",
        exportCSV: "Export scans CSV",
        exportXML: "Export scans XML",
        importReferenceFile: "Import Reference File",
        exportReferenceFile: "Export Reference File",
        exportSingleScan: "Export single scan",
        create: "Create scan",
    },
    lots: { update: "Update Lot", create: "Create Lot", delete: "Delete Lots" },
    materials: {
        update: "Update Material",
        create: "Create Material",
        delete: "Delete Materials",
    },
    materialGroups: {
        update: "Update Material Group",
        create: "Create Material Group",
        delete: "Delete Material Groups",
    },
    measurements: { create: "Create Measurement" },
    publishedProducts: {
        comment: "Comment on published product",
        delete: "Delete published product",
    },
    scanFilters: {
        delete: "Delete scan filter",
        editName: "Edit scan filter name",
    },
});

const ENTITIES = Object.freeze({
    models: "Models",
    modelParameters: "Model Parameters",
    scans: "Scans",
    lots: "Lots",
    materials: "Materials",
    materialGroups: "Material Groups",
    measurements: "Measurements",
    publishedProducts: "Published Products",
    scanFilters: "Scan Filters",
});

export { ACTIONS, ENTITIES };
